import { css, type Theme } from "@emotion/react";

import * as dimensions from "@styles/emotion-styles/dimensions";

export const header = (theme: Theme) => css`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: ${theme.ds5.spacing.gap.medium};
  padding: ${theme.ds5.page.paddingY.small} ${theme.ds5.column.web.margin};
  background-color: ${theme.ds5.surface.level0};

  @media (max-width: ${dimensions.phoneLargeMax}) {
    justify-content: center;
  }
`;

export const brand = (theme: Theme) => css`
  display: flex;
  align-items: center;
  gap: ${theme.ds5.gap[300]};
`;

export const logo = css`
  width: 130px;
`;

export const productName = css`
  text-transform: uppercase;
  letter-spacing: 2px;
`;

export const betaPill = css`
  text-transform: uppercase;
  letter-spacing: 1px;
`;
